import React, {Component} from 'react';
import {findDOMNode} from 'react-dom';
import lang from '../../../lang/index';

class StopLive extends Component {

    backhome() {
        hashHistory.push('/home');
    }

    retry = ()=>{
        this.props.reconnectRoom();
    };

    render() {
        return (
            <div className="excetion-wrap livend">
                <div className="content">{lang.template('连接直播间超时')}</div>
                <div className="btns">
                    <button onClick={this.retry}>{lang.template('再试一次')}</button>
                    { 
                        this.props.from !== 'home' ? <button className="gray" onClick={this.backhome}>{lang.template('去看看其他主播')}</button> : null
                    }
                </div>
            </div>
        );
    }
}

export default StopLive;


// WEBPACK FOOTER //
// ./js/living/view/exception/timeout.js